import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as Const from "../../../Data/const";
import { action } from "../../../Data";
import { parseUrlParameter } from "../../../Lib/Utils";

class FacebookRedirect extends Component {
  constructor(props) {
    super(props);
    this.loadFacebookLoginApi = this.loadFacebookLoginApi.bind(this);
  }

  componentDidMount() {
    this.loadFacebookLoginApi();
  }

  loadFacebookLoginApi() {
    if (Const.checkDevice() === "ios") {
      let query = parseUrlParameter.parse(window.location.search);

      let state = JSON.parse(query.state);
      let access_token;

      const params = {
        client_id: Const.FACEBOOK.appId,
        redirect_uri: state.redirect_uri,
        client_secret: Const.FACEBOOK.client_secret,
        code: query.code
      };

      const searchParams = Object.keys(params)
        .map(key => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");

      const getAccessTokenPromise = () => {
        return fetch(
          "https://graph.facebook.com/v4.0/oauth/access_token?" + searchParams,
          {
            method: "GET"
          }
        ).then(response => {
          return response.json();
        });
      };

      const getProfilePromise = token => {
        return fetch(
          "https://graph.facebook.com/debug_token?input_token=" +
            token +
            "&access_token=" +
            Const.FACEBOOK.app_token,
          {
            method: "GET"
          }
        ).then(response => {
          return response.json();
        });
      };

      getAccessTokenPromise()
        .then(data => {
          access_token = data.access_token;
          return getProfilePromise(access_token);
        })
        .then(response => {
          this.props
            .dispatch(
              action.eUSER.login({
                uid: "facebook!" + response.data.user_id,
                snsToken: access_token
              })
            )
            .then(response => {
              if (!response.user) throw new Error("No User");
              Const.showAlert(
                "",
                response.user.name + "님 " + Const.LOGIN_SUCCESS_MESSAGE
              );
              localStorage.setItem(Const.TOKEN["user"], response.token);
              localStorage.setItem(Const.LOGIN_TIME["user"], new Date());

              let loginValue = null;
              if (response.user.email) {
                loginValue = response.user.email;
              } else {
                let uidTypeAndId = response.user.uid.split("!");

                loginValue = uidTypeAndId[1];
              }
              console.log(loginValue);

              Const.onLoginSuccess(response.token, loginValue);
              let queryKeys = (Object.keys(state) || []).filter(key => {
                return key && key !== "redirect_uri" && key !== "href";
              });

              let urlQuery =
                queryKeys.length > 0
                  ? "?" +
                    queryKeys
                      .map(key => {
                        return key + "=" + state[key];
                      })
                      .join("&")
                  : "";

              window.location.replace(
                "https://test.mcheckplus.com/user/verification"
              );
            })
            .catch(err => {
              Const.showAlert("", Const.LOGIN_WARNING_MESSAGE);
              window.location.replace(
                "https://test.mcheckplus.com/user/verification"
              );
            });
        });
    } else {
      let query = parseUrlParameter.parse(window.location.search);
      const id = query.id;
      const access_token = query.token;
      this.props
        .dispatch(
          action.eUSER.login({
            uid: "facebook!" + id,
            snsToken: access_token
          })
        )
        .then(response => {
          if (!response.user) throw new Error("No User");
          Const.showAlert(
            "",
            response.user.name + "님 " + Const.LOGIN_SUCCESS_MESSAGE
          );
          localStorage.setItem(Const.TOKEN["user"], response.token);
          localStorage.setItem(Const.LOGIN_TIME["user"], new Date());

          let loginValue = null;
          if (response.user.email) {
            loginValue = response.user.email;
          } else {
            let uidTypeAndId = response.user.uid.split("!");

            loginValue = uidTypeAndId[1];
          }

          Const.onLoginSuccess(response.token, loginValue);

          window.location.replace(
            "https://test.mcheckplus.com/user/verification"
          );
        })
        .catch(err => {
          Const.showAlert("", Const.LOGIN_WARNING_MESSAGE);
          window.location.replace(
            "https://test.mcheckplus.com/user/verification"
          );
        });
    }
  }

  render() {
    return <div />;
  }
}

export default connect(state => {
  return {
    eSESSION: state.data.eSESSION.eSESSION
  };
})(withRouter(FacebookRedirect));
